import React, {useEffect, useState} from 'react';
import Welcome from '.';
import StampSubmitterForm from '../../organisms/stamp-submitter-form';
import Http from '../../../http';
import ErrorHandler from '../../../utils/error-handler';
import {connect} from "react-redux";
import { toast } from 'react-toastify';
import { setStampSubmitter } from "../../../redux/modules/user";
import Transition from "../../../utils/transition";
import Analytics from "../../../analytics";

const format2Digit = value => String(value).length === 1 ? `0${String(value)}` : String(value);

const Main = ({setStampSubmitter}) => {
  const [isRequesting, setIsRequesting] = useState(false);
  useEffect(() => {
    Analytics.welcomeStampSubmitterSettingLanding(true);
  }, []);
  const updateStampSubmitter = async (formData) => {
    setIsRequesting(true);
    const convertedBirthday = `${formData.birthday.year}-${format2Digit(formData.birthday.month)}-${format2Digit(formData.birthday.day)}T00:00:00.000Z`;
    const body = {
      name: formData.name,
      qualification: formData.qualification === 'その他' ? formData.otherQualification : formData.qualification,
      birthday: convertedBirthday,
      typeOfCalendar: formData.typeOfCalendar,
    };
    await Http.updateStampSubmitter(
      body,
      res => {
        setIsRequesting(false);
        toast.success('事前設定が完了しました。');
        setStampSubmitter(res.data.stampSubmitter);
        Analytics.welcomeStampSubmitterSettingDone(true);
        Transition.goTo('/entries/new');
      },
      e => {
        setIsRequesting(false);
        ErrorHandler.common(e.response.status);
      },
    )
  };
  return (
    <Welcome stepName='印鑑提出者設定'>
      <p className="has-text-weight-bold">あなたの所属する法人の印鑑提出者の情報を教えてください。</p>
      <p className="is-size-7">代表印の印鑑登録の申請時に
        <a href="http://houmukyoku.moj.go.jp/homu/content/001188212.pdf" target="_blank" rel="noopener noreferrer">
          印鑑届書
        </a>
        に記載した内容を入力してください。</p>
      <div style={{padding: '30px 0 0 0'}}>
        <StampSubmitterForm
          onSubmit={v => updateStampSubmitter(v)}
          isRequesting={isRequesting}
        />
      </div>
    </Welcome>
  )
};

export default connect(
  null,
  {setStampSubmitter}
)(Main);